import { generateBackgroundImgUrl, setStylesOnElement, returnTextOrDefaultTextByType } from "../util/Misc";
import { FOOTER_STATES } from "../model/Constants";
import {footerbuttonRender} from "./templates/renders/footerbutton";
import ChatPosition from "../util/ChatPosition";

const FooterButton: any = {
    tagName: "footer-button",
    initialize(options) {
        initComponent(options);
    },
    renderer: footerbuttonRender,
    created() {
        this.button = this.el.querySelector("input[type='submit']");
        this.toggleSendButtonState(false);

        this.footerArea = document.querySelector("footer-area");
        this.data.text = returnTextOrDefaultTextByType(this.prop);
        this.udpateBackground(this.prop);

        if (this.prop.type == "Emoji") {
            this.eInsta = null;
        }
    },
    disableButton() {
        if (this.prop.state && this.prop.state.indexOf(FOOTER_STATES.INPUT) != -1) {
            this.toggleEnabledState(false);
        }
    },
    enableButton() {
        if (this.prop.state && this.prop.state.indexOf(FOOTER_STATES.INPUT) != -1) {
            this.toggleEnabledState(true);
        }
    },

    /**
     * We're binding the touchStart event to this method to help keep the virtual keyboard up on mobile devices by
     * calling preventDefault.
     *
     * We also bind the click event for desktop devices.
     *
     * Mobile device's screen-readers can send a click event instead of a touch event when you activate a button, in
     * this case, preventDefault also disables the following MouseEvent from triggering, which helps us avoid calling this method twice.
     * See https://w3c.github.io/touch-events/#example-5
     *
     * @param {MouseEvent|TouchEvent|PointerEvent}   e   The click or touch event for the button
     */
    onButtonClick(e: MouseEvent | TouchEvent | PointerEvent) {
        if (this.prop.type === "Send") {
            this.footerArea.sendCustomerMessage();
        }

        if (this.prop.type === "Emoji") {
            if (!this.eInsta) {
                this.eInsta = document.createElement("emoji-picker");
                this.$app.shoutui.getLayoutEl().appendChild(this.eInsta);
                this.eInsta.setInputElement(this.footerArea.getInputElement());
            }

            this.eInsta.setVisible();
        }

        if (this.prop.type === "Move") {
            ChatPosition.togglePosition();
        }

        if (e) {
            e.preventDefault();
        }
    },

    /**
     * update send button background image
     * @param {ImageO} propObj
     */
    udpateBackground(propObj) {
        this.defaultImgUrl = generateBackgroundImgUrl(propObj, this.$app);

        if (this.defaultImgUrl) {
            this.button.style.backgroundImage = this.defaultImgUrl;
            this.disableImgUrl = generateBackgroundImgUrl({
                imgSrc: this.prop.dImgSrc,
                imgName: this.prop.dImgName,
            }, this.$app);
        }
    },

    /**
     * Allows the display of disabled and enabled styles
     * @param {boolean} isTyping
     */
    toggleSendButtonState(isTyping) {
        if ((this.prop.state == "undefined" && this.prop.type == "Send")
            || (this.prop.state && this.prop.state.indexOf(FOOTER_STATES.TYPING) != -1)
        ) {
            this.toggleEnabledState(isTyping);
        }
    },
    toggleEnabledState(enable) {
        window.raf(() => {
            if (enable && this.defaultImgUrl && this.disableImgUrl) {
                this.button.style.backgroundImage = this.defaultImgUrl;
                this.button.removeAttribute("disabled");
            } else if (!enable && this.disableImgUrl) {
                this.button.style.backgroundImage = this.disableImgUrl;
                this.button.setAttribute("disabled", true);
            } else if (!enable && this.config.disableStateStyle) {
                // .style.cssText = this.config.disableStateStyle;
                setStylesOnElement(this.config.disableStateStyle, this.button);
                this.button.setAttribute("disabled", true);
            } else if (this.config.enableStateStyle) {
                // this.sendButton.style.cssText = this.config.enableStateStyle;
                setStylesOnElement(this.config.enableStateStyle, this.button);
                this.button.removeAttribute("disabled");
            }
        });
    },
};

export default appInstance => {
    FooterButton.$app = appInstance;
    return FooterButton;
};

const initComponent = (options: any) => {
    const appInstance = options.$app;
    const dt = appInstance.getSDKInstance().getDeviceType();
    const footerConfig = appInstance.getUIConfig().footerConfig || {};

    if (footerConfig) {
        options.constants = {
            sendButtonStyles: footerConfig.sendButtonStyles,
            footerButtonStyles: footerConfig.sendButtonStyles,
            config: footerConfig.footerSettings || {},
            isMobile: dt == "Phone" || dt == "Tablet",
        };

        options.data = {
            text: ""
        };

        options.constants.config.disableStateStyle = footerConfig.disableStateStyle;
        options.constants.config.enableStateStyle = footerConfig.enableStateStyle;
    }
};
